import React from 'react';
import ScansBrowser from '../../../components/ScansBrowser';

const ScansTab: React.FC = () => <ScansBrowser />;

export default ScansTab;
